var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "kundenportal-product-combo" },
    [
      _vm.showMatNr
        ? [
            _c("div", { staticClass: "kpc__product__label" }, [
              _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.matnr"))),
            ]),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.product.matnr))]),
          ]
        : _c("div"),
      _vm._v(" "),
      !_vm.omitApplicationColumn
        ? _c("div", { staticClass: "kpc__product__label" }, [
            _vm._v(
              _vm._s(
                _vm.$t("kundenportal-product-combos.recommended_application")
              )
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.omitApplicationColumn
        ? _c("div", [
            _vm._v(_vm._s(_vm.product.recommended_application.join(", "))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "kpc__product__label" }, [
        _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.dimension"))),
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(_vm._s(_vm.product.format) + " x " + _vm._s(_vm.product.height)),
        _vm.product.kante ? _c("br") : _vm._e(),
        _vm._v(_vm._s(_vm.product.kante)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "kpc__product__label" }, [
        _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.quantities_stock"))),
      ]),
      _vm._v(" "),
      (_vm.product.moq_stock && _vm.product.moq_stock.length > 0) ||
      (_vm.product.inc_stock && _vm.product.inc_stock.length > 0)
        ? _c("div", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.product.moq_stock || 0) +
                "\n        /\n        " +
                _vm._s(_vm.product.inc_stock || 0) +
                "\n    "
            ),
          ])
        : _c("div"),
      _vm._v(" "),
      _c("div", { staticClass: "kpc__product__label" }, [
        _vm._v(
          _vm._s(_vm.$t("kundenportal-product-combos.quantities_production"))
        ),
      ]),
      _vm._v(" "),
      (_vm.product.moq_prod && _vm.product.moq_prod.length > 0) ||
      (_vm.product.inc_prod && _vm.product.inc_prod.length > 0)
        ? _c("div", [
            _vm._v(
              "\n        " +
                _vm._s(_vm.product.moq_prod || 0) +
                "\n        /\n        " +
                _vm._s(_vm.product.inc_prod || 0) +
                "\n    "
            ),
          ])
        : _c("div"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "kpc__product__label" },
        [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.check_title"))),
          ]),
          _vm._v(" "),
          _c("global-tooltip", [
            _c("p", {
              staticClass: "check-notice",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("kundenportal-product-combos.check_tooltip")
                ),
              },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.product.allow_check
        ? _c(
            "form",
            {
              staticClass: "kpc__check__form",
              on: { submit: (e) => _vm.checkStock(e) },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.input,
                    expression: "input",
                  },
                ],
                staticClass: "kpc__check__input form__input form__input--text",
                attrs: { size: "5", maxlength: "5" },
                domProps: { value: _vm.input },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.input = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              !_vm.input
                ? _c("span", { staticClass: "kpc__check__hint" }, [
                    _vm._v(
                      _vm._s(_vm.$t("kundenportal-product-combos.check_hint"))
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.input && !_vm.apiResult
                ? _c(
                    "button",
                    { staticClass: "kpc__check__btn button button--secondary" },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("kundenportal-product-combos.do_check")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.apiResult
                ? [
                    _c("div", { staticClass: "kpc__check__result" }, [
                      _c("div", {
                        staticClass: "kpc__check__status",
                        class: {
                          "kpc__check__status--green":
                            _vm.apiResult.status === "🟢",
                          "kpc__check__status--yellow":
                            _vm.apiResult.status === "🟡",
                          "kpc__check__status--red":
                            _vm.apiResult.status === "🔴",
                        },
                      }),
                      _vm._v(" "),
                      _vm.apiResult.status === "🟡" ||
                      _vm.apiResult.status === "🔴"
                        ? _c("div", [
                            "w" in _vm.apiResult
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "kundenportal-product-combos.check_result_week"
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.weekNumber(0)) +
                                      ": " +
                                      _vm._s(_vm.apiResult.w) +
                                      " " +
                                      _vm._s(_vm.piecesLabelW) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            "w1" in _vm.apiResult
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "kundenportal-product-combos.check_result_week"
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.weekNumber(1)) +
                                      ": " +
                                      _vm._s(_vm.apiResult.w1) +
                                      " " +
                                      _vm._s(_vm.piecesLabelW1) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            "w2" in _vm.apiResult
                              ? _c("div", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "kundenportal-product-combos.check_result_week"
                                      )
                                    ) +
                                      " " +
                                      _vm._s(_vm.weekNumber(2)) +
                                      ": " +
                                      _vm._s(_vm.apiResult.w2) +
                                      " " +
                                      _vm._s(_vm.piecesLabelW2) +
                                      "\n                    "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [_vm._v(_vm._s(_vm.apiResult.message))]),
                    ]),
                  ]
                : _vm._e(),
            ],
            2
          )
        : _c("div", [
            _vm._v(_vm._s(_vm.$t("kundenportal-product-combos.no_check"))),
          ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }